<template>
  <div class="short-answer-container">
    <div class="question-stem">{{question.Question}}</div>
    <textarea
      class="short-response"
      placeholder="Your Answer"
      :name="question.QuestionID"
      :value="question.Comment"
      @input="dispatchInput"
      :maxlength="maxCharacters"
    ></textarea>
    <div
      class="character-limit"
      :class="{'near-limit': charactersRemaining() < 100 , 'reached-limit': charactersRemaining() === 0}"
    >{{`${characters}/${maxCharacters}`}}</div>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      characters: 0,
      maxCharacters: 1500
    };
  },
  methods: {
    dispatchInput(event) {
      this.characters = event.target.value ? event.target.value.length : 0;
      this.$emit("dispatch-input", {
        questionId: this.question.QuestionID,
        Comment: event.target.value
      });
    },
    charactersRemaining() {
      return this.maxCharacters - this.characters;
    }
  }
};
</script>

<style scoped>
.question-stem {
  font-family: Arial;
  font-size: 1em;
  text-align: justify;
  color: #000000;
  margin-bottom: 0.75em;
  max-width: 90%;
  line-height: 1.2;
}
.answer {
  font-family: Arial;
  font-size: 1em;
  text-align: justify;
  color: #979797;
  border-bottom: 1px solid grey;
  padding: 0.25em;
}
textarea {
  border: 1px solid;
  font-family: Arial;
  font-size: 1em;
  text-align: justify;
  color: #4a4a4a;
  width: 80%;
  height: 8em;
  margin-top: 0.75em;
}
.character-limit {
  font-size: 0.8em;
  font-family: Arial, Helvetica, sans-serif;
  color: gray;
}
.near-limit {
  color: #ffc107;
}
.reached-limit {
  color: #dc3545;
}
.short-answer-container {
  margin-bottom: 3.5em;
  padding-left: 0.5em;
}
@media only screen and (min-width: 1200px) {
  .question-stem {
    font-family: Arial;
    font-size: 1.25em;
    text-align: justify;
    color: #000000;
    margin-bottom: 0.75em;
    line-height: 1.2;
  }
  .answer {
    font-family: Arial;
    font-size: 1.1em;
    text-align: justify;
    color: #979797;
    border-bottom: 1px solid grey;
    padding: 0.25em;
  }
  .character-limit {
    font-size: 0.8em;
    font-family: Arial, Helvetica, sans-serif;
    color: gray;
  }
  .near-limit {
    color: #ffc107;
  }
  .reached-limit {
    color: #dc3545;
  }
}
</style>